import { useEffect, useState } from "react";
import { useApi } from "utils"

export type SuccessFetch = {
    status: string;
    responseStatus: number;
    message: string;
    payload: string;
};

export function useProjectCode(date:string) {
    const api = useApi()
    const [code, setCode] = useState("")
    
    const fetchData = () => {
        api.post(`project/generate-code?date_request=${date}`)
        .then((res) => {
            const response: SuccessFetch = res.data;
            setCode(response.payload)
        })
        .catch(() => {
            setCode("");
        })
    }

    useEffect(()=>{
        fetchData()
        // eslint-disable-next-line
    },[])

    return{
        code
    }
}